module.exports = __webpack_public_path__ + "static/media/most-active-no-data.988470cc.jpg";